'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = GBDateToAge;
// date must be DD/MM/YYYY (the '/' can be another character)

function GBDateToAge(date) {
  var connector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/';
  if (
  // validate the input
  date.length !== 10 || date.substr(2, 1) !== connector || date.substr(5, 1) !== connector) {
    throw new Error('gbDateToAge requires a date string with the format DD/MM/YYYY');
  }

  // get the date parts of the DOB
  var dob = {};
  dob.day = date.substr(0, 2);
  dob.month = date.substr(3, 2);
  dob.year = date.substr(6, 4);

  // get the date parts of today
  var dateObj = new Date();
  var today = {};
  today.day = dateObj.getDate();
  today.month = dateObj.getMonth() + 1;
  today.year = dateObj.getFullYear();

  // get the year difference
  var yearsDiff = today.year - dob.year;

  // catch 0yr olds & future beings
  if (!yearsDiff) {
    throw new Error('gbDateToAge requires an age of at least 1');
  }

  // deduct a year if this year's birthday is before today
  if (today.month < dob.month) {
    yearsDiff -= 1;
  } else if (today.month === dob.month && today.day < dob.day) {
    yearsDiff -= 1;
  }
  return yearsDiff;
}